import React from "react";
import { useTranslation } from "react-i18next";

const logos = [
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/meta.png",
    alt: "Meta",
    // key: "meta",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/vivago.png",
    alt: "Vivago",
    key: "vivaGo",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/trae.png",
    alt: "Trae",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/qacdora.png",
    alt: "Qacdora",
    key: "pacdora",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/shakker.png",
    alt: "Shakker",
    key: "shakker",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/shopme.png",
    alt: "Shopme",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/vizard.png",
    alt: "Vizard",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/roboneo.png",
    alt: "Roboneo",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/notta.png",
    alt: "Notta",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/roleza.png",
    alt: "Roleza",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/onlyoffice.png",
    alt: "Onlyoffice",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/aippt.png",
    alt: "Aippt",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/pageon.png",
    alt: "Pageon",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/Mootion.png",
    alt: "Mootion",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/laipic.png",
    alt: "Laipic",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/fantasia.png",
    alt: "Fantasia",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/lyfefuel.png",
    alt: "Lyfefuel",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/puroxy.png",
    alt: "Puroxy",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/mylil.png",
    alt: "Mylil",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/oneHash.png",
    alt: "OneHash",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/brand-logo/auro.png",
    alt: "Auro",
  },
];

export default function LogoScroll() {
  const { t } = useTranslation();
  return (
    <div className="logo-carousel-container mt-10">
      <div className="flex justify-start items-center gap-[56px] mb-4">
        <div className="flex-1 h-[1px] bg-divide" />
        <div className="justify-start text-font&icon-helper text-sm font-medium font-['DM_Sans'] leading-snug">
          {t("components.checkDepositModal.extraRights")}
        </div>
        <div className="flex-1 h-[1px] bg-divide" />
      </div>
      <div className="logo-carousel-track">
        {/* 第一组logo */}
        {logos.map((logo, index) => (
          <div
            className={`logo-item flex-shrink-0 relative min-h-[50px] flex items-end ${
              logo.key ? "cursor-pointer" : ""
            }`}
            key={`first-${index}`}
            onClick={() => {
              if (logo.key) {
                window.open(
                  `https://www.ahacreator.com/case-studies?type=${logo.key}`,
                  "_blank"
                );
              }
            }}
          >
            <img src={logo.src} alt={logo.alt} className="w-full" />
            {logo?.key && (
              <div className="bg-[#FFEAD5] absolute top-[0] left-[10px] flex items-center px-[4px] text-[#FB6011] text-[10px] font-medium font-['DM_Sans'] leading-normal rounded-full">
                {t("components.checkDepositModal.caseStudy")}
              </div>
            )}
          </div>
        ))}

        {/* 第二组logo（用于无缝循环） */}
        {logos.map((logo, index) => (
          <div
            className={`logo-item flex-shrink-0 relative min-h-[50px] flex items-end ${
              logo.key ? "cursor-pointer" : ""
            }`}
            key={`second-${index}`}
            onClick={() => {
              if (logo.key) {
                window.open(
                  `https://www.ahacreator.com/case-studies?type=${logo.key}`,
                  "_blank"
                );
              }
            }}
          >
            <img src={logo.src} alt={logo.alt} className="w-full" />
            {logo?.key && (
              <div className="bg-[#FFEAD5] absolute top-[0] left-[10px] flex items-center px-[4px] text-[#FB6011] text-[10px] font-medium font-['DM_Sans'] leading-normal rounded-full">
                {t("components.checkDepositModal.caseStudy")}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
